const getLpName = (symbol: string) => `${[symbol, "UST"].join("-")} LP`
export default getLpName
